import { useQuery } from '@tanstack/react-query';
import { motion } from 'framer-motion';
import { adminApi } from '../../../api/adminApi';
import './DashboardPanel.css';

export default function DashboardPanel() {
    const { data: stats, isLoading } = useQuery({
        queryKey: ['admin', 'stats'],
        queryFn: adminApi.getStats,
        refetchInterval: 30000, // Refresh every 30 seconds
    });

    if (isLoading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner">⟳</div>
                <p>Loading dashboard...</p>
            </div>
        );
    }

    const statCards = [
        {
            title: 'Total Orders',
            value: stats?.totalOrders || 0,
            icon: '📦',
            color: 'cyan',
        },
        {
            title: 'Pending Orders',
            value: stats?.pendingOrders || 0,
            icon: '⏳',
            color: 'yellow',
        },
        {
            title: 'Completed Orders',
            value: stats?.completedOrders || 0,
            icon: '✅',
            color: 'green',
        },
        {
            title: 'Total Volume',
            value: `$${(stats?.totalVolume || 0).toLocaleString()}`,
            icon: '💰',
            color: 'purple',
        },
    ];

    return (
        <div className="dashboard-panel">
            <div className="stats-grid">
                {statCards.map((card, index) => (
                    <motion.div
                        key={card.title}
                        className={`stat-card glass stat-${card.color}`}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.1 }}
                    >
                        <div className="stat-icon">{card.icon}</div>
                        <div className="stat-content">
                            <h3 className="stat-title">{card.title}</h3>
                            <p className="stat-value">{card.value}</p>
                        </div>
                    </motion.div>
                ))}
            </div>

            <div className="dashboard-section">
                <h2 className="section-title">Quick Actions</h2>
                <div className="quick-actions">
                    <button className="action-btn glass">
                        <span>📊</span>
                        View All Orders
                    </button>
                    <button className="action-btn glass">
                        <span>💸</span>
                        Recent Transactions
                    </button>
                    <button className="action-btn glass">
                        <span>👛</span>
                        Manage Wallets
                    </button>
                    <button className="action-btn glass">
                        <span>⚙️</span>
                        System Settings
                    </button>
                </div>
            </div>

            <div className="dashboard-section">
                <h2 className="section-title">System Status</h2>
                <div className="status-grid">
                    <div className="status-item glass">
                        <span className="status-label">Backend API</span>
                        <span className="status-badge status-online">Online</span>
                    </div>
                    <div className="status-item glass">
                        <span className="status-label">Database</span>
                        <span className="status-badge status-online">Connected</span>
                    </div>
                    <div className="status-item glass">
                        <span className="status-label">Queue System</span>
                        <span className="status-badge status-online">Active</span>
                    </div>
                    <div className="status-item glass">
                        <span className="status-label">Blockchain RPC</span>
                        <span className="status-badge status-online">Synced</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
